<template lang="pug">
  .modal.modal--sm
    h2.modal__title(
    v-if="modalData.title"
    ) {{ modalData.title }}
    p.modal__text(
    v-if="modalData.text"
    :class="{ 'modal__text--center': modalData.alignCenter }"
    ) {{ modalData.text }}
    .modal__button
      button.button.button_paint-main.button_full(
      @click="onButtonClick"
      )
        .button__text {{ modalData.buttonText || 'Спасибо' }}
</template>

<script>
import { mapActions } from "vuex";
import jwtDecode from "jwt-decode";

export default {
  name: "notification",
  props: ["modalData"],
  computed: {
    registration_token() {
      return this.$route.query.registration_token;
    },
  },
  methods: {
    ...mapActions(["confirmRegistration", "getUser", "resendAuthLink"]),
    onButtonClick() {
      this.$emit("close");
      if (this.modalData.redirectToProfile) {
        this.$router.push({ name: "user-profile" });
      }
      if (this.modalData.redirectToRequests) {
        this.$router.push({ name: "operator-requests-quota" });
      }
    },
  },
  mounted() {
    let registration_token = this.registration_token;
    if (registration_token) {
      this.confirmRegistration({
        data: {
          token: registration_token,
        },
      }).then((res) => {
        let query = Object.assign({}, this.$route.query);
        delete query.registration_token;
        this.$router.replace({ query });

        let resData = res.data;
        if (res.status === 200) {
          this.getUser();
          this.$emit("changeModalMode", "notification", {
            title: "Ваш аккаунт подтвержден",
            text: "Теперь вам необходимо заполнить профиль",
            redirectToProfile: true,
          });
        } else if (res.status === 400 && resData.code.message === "3") {
          let dataJwtDecode = jwtDecode(registration_token);
          this.resendAuthLink(dataJwtDecode).then(() => {
            this.$emit("changeModalMode", "notification", {
              title:
                "Ссылка по которой вы пытались перейти просрочена, мы выслали вам новую на email",
              text: "",
            });
          });
        } else if (res.status === 404) {
          this.$emit("changeModalMode", "notification", {
            title: "Пользователь уже был подтвержден",
            text: "",
          });
        } else {
          this.$emit("changeModalMode", "notification", {
            title: `Статус -> ${res.status}`,
            text: `${resData.detail.message}`,
          });
        }
      });
    }
  },
};
</script>
